<template>
  <div class="zy-html">
    <div class="zy-body" style="overflow-x: hidden;background-color: white;">
      <Navigator/>
      <BannerSwiper/>

      <div :style="{
        backgroundImage: 'url(' + bg + ')',
        }" class="con-bg">
        <Vision/>
        <Icons style="padding-bottom: 60px"/>
      </div>
      <Ad title="去繁从简 返璞归真"
          desc="12年开发经验  深入行业交流 从实际出发 利用数字化方案解决行业复杂 繁琐流程 快速提升效率"
          style="margin-top: 0px"
          :bg="require('@/assets/images/index/ads/ad1.jpeg')"
      />
      <Industry/>
      <Ad title="海纳百川 诚信天下"
          style="margin-top: 20px"
          desc="始终坚守诚信第一 与君为友 欢迎八方来客同心同力 打造诚信且高性价比的数字系统应。"
          :bg="require('@/assets/images/index/ads/ad2.jpg')"
      />

      <Map/>
      <Custom/>
      <ContactFloat/>

      <Footer/>


    </div>
  </div>
</template>

<script>
import Navigator from './widgets/navigator.vue'
import BannerSwiper from "./widgets/banner-swiper.vue";
import Footer from './widgets/footer.vue'
import Vision from "@/views/index/widgets/Vision.vue";
import Icons from "@/views/index/widgets/Icons.vue"
import Ad from '@/views/index/widgets/Ad.vue'
import Industry from "@/views/index/widgets/industry.vue";
import Map from "@/views/index/widgets/Map.vue";
import Custom from "@/views/index/widgets/Custom.vue";
import ContactFloat from './widgets/contact-float'

export default {
  components: {
    ContactFloat,
    Industry,
    Icons,
    Vision,
    Ad,
    Navigator,
    BannerSwiper,
    Footer,
    Map,
    Custom,
  },
  data() {
    return {
      bg: require('@/assets/images/index/bg-3.png')
    }
  }
}
</script>

<style scoped lang="scss">
.con-bg {
  background-size: 100%;
  background-repeat: no-repeat;
}
</style>
